import styled from "styled-components";
export const GatewaySelectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  h5 {
    width: 100%;
  }
  .notice {
    width: 100%;
    font-size: 12px;
    margin-bottom: 8px;
  }
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 2px #ccc;
    border-radius: 10px;
    margin: 5px;
    padding: 8px 16px;
    cursor: pointer;
    img {
      height: 48px;
      opacity: 0.7;
      transition: 0.2s all;
    }
    &:hover {
      img {
        opacity: 1;
      }
    }
  }
  .selected {
    border-color: #5d5d5d;
    background-color: #fffcee;
    cursor: default;
    img {
      opacity: 1;
    }
  }
`;
